import type { HTMLAttributes, ReactNode } from "react";
import { CountRoot, Root, type BadgeVariant } from "./style";

// Legacy color strings → new variants (compat para consumidores antigos).
const legacyColorMap: Record<string, BadgeVariant> = {
  primary: "primary",
  secondary: "accent",
  success: "success",
  warning: "warning",
  danger: "danger",
  unabled: "ghost",
  info: "info",
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  /** @deprecated Use `variant` instead. Mantido para compat com consumidores legacy. */
  color?: string;
  /** @deprecated Mantido para compat; novos consumidores devem usar `variant`. */
  uppercase?: boolean;
  children: ReactNode;
}

export function Badge({
  variant,
  color,
  uppercase: _uppercase,
  children,
  ...rest
}: BadgeProps) {
  const resolved: BadgeVariant =
    variant ??
    (color ? (legacyColorMap[color] ?? "primary") : "primary");
  return (
    <Root $variant={resolved} {...rest}>
      {children}
    </Root>
  );
}

/**
 * How many things wait for someone (spec 20261028-130000 AC-5). The owner found the tabs' count too pale to notice
 * (smoke of 2026-10-28). Nothing is drawn at zero; above 99 it reads "99+". `label` says what is counted.
 */
export function CountBadge({ count, label }: { count: number; label: string }) {
  if (count <= 0) return null;
  return (
    <CountRoot role="status" aria-label={`${count} ${label}`}>
      {count > 99 ? "99+" : count}
    </CountRoot>
  );
}

export default Badge;
export type { BadgeVariant } from "./style";
